import React from 'react';
import { useField, useForm } from 'react-final-form';

import useWizardContext from '@swf/core/hooks/useWizardContext';

import { CashierFlowType } from '../../../types/Cashier';
import Prompt from '../../Prompt/Prompt';

import PepHio from './PepHio/PepHio';
import {
  TXTWCL_Continue,
  TXTWCL_Information_needed
} from './PepHioAndThirdPartyCheck.messages.json';
import ThirdParty from './ThirdParty/ThirdParty';

interface Props {
  onClose(): void;
}

const PepHioAndThirdPartyCheck: React.FC<Props> = ({ onClose }) => {
  const {
    input: { value: thirdPartyValue }
  } = useField('thirdParty', {
    subscription: { value: true }
  });
  const {
    input: { value: pepHioValue }
  } = useField('pepHio', {
    subscription: { value: true }
  });
  const form = useForm();
  const {
    data,
    values: { deposit }
  } = useWizardContext();

  const isPepCheck = data.preCashinInfo?.pepCheck || data.preCashinData?.pepCheck;

  const handleContinue = () => {
    onClose();
    if (data.cashierFlow === CashierFlowType.FirstDeposit) {
      deposit.cumulativeCheck = true;
      deposit.pepCheck = isPepCheck && pepHioValue === 'yes';
      deposit.thirdPartyCheck = thirdPartyValue === 'yes';
    } else {
      data.preCashinData = {
        cumulativeCheck: true,
        pepCheck: isPepCheck && pepHioValue === 'yes',
        thirdPartyCheck: thirdPartyValue === 'yes'
      };
      data.pepHioAndThirdPartyCheckPassed = true;
    }
    form.submit();
  };

  return (
    <Prompt
      variant="warning"
      title={{
        translation: TXTWCL_Information_needed
      }}
      primaryButton={{
        translation: TXTWCL_Continue,
        disabled: !isPepCheck ? !thirdPartyValue : !thirdPartyValue || !pepHioValue
      }}
      onPrimaryButtonClick={handleContinue}
      onClose={onClose}
    >
      {isPepCheck && <PepHio />}
      <ThirdParty />
    </Prompt>
  );
};

export default PepHioAndThirdPartyCheck;
